import doFetch from 'utils/do_fetch'

export const fetchMyApprovalsDetailsList = async (payload = {}) => {
  const myApprovals = window.location.pathname.includes('/my-approvals')
  let queryParams = myApprovals
    ? 'requestType=myApprovals'
    : 'requestType=myRequests'
  const listData = await doFetch({
    path: `/v1/approvals/${payload}?${queryParams}`,
    method: 'get',
  })
  return listData
}

export const fetchApproversList = async (payload = {}) => {
  const listData = await doFetch({
    path: `/v1/approvals/${payload.id}/approver-groups/${payload.groupId}`,
    method: 'get',
  })
  return listData
}

export const fetchResourceLabels = async (payload = '') => {
  const listData = await doFetch({
    path: `/resource-manager/${payload}/labels`,
    method: 'get',
  })
  return listData
}

export const fetchResourceLabelDetails = async (payload = '') => {
  const listData = await doFetch({
    path: `/resource-manager/${payload}/label-details`,
    method: 'get',
  })
  return listData
}
